import React from "react";
import stylesV1 from "./PageInfo_css/PageInfoV1.module.css"
import stylesV2 from "./PageInfo_css/PageInfoV2.module.css"
import stylesV3 from "./PageInfo_css/PageInfoV3.module.css"
import stylesV4 from "./PageInfo_css/PageInfoV4.module.css"
import stylesV5 from "./PageInfo_css/PageInfoV5.module.css"
import FadeInSection from "./FadeInSection";
// import stylesV5 from "./PageInfo_css/PageInfoV5.module.css"
// import stylesV6 from "./PageInfo_css/PageInfoV6.module.css"

    // There a six differnt styles to the page info, by using the "version" argument.
    // The argument can have four values, v1, v2, v3, v4, v5 and v6. Depending on the value
    // one of the styles will be choosen for the component.


export default function PageInfoOne({title, image, description, version}) {

    //Switch between styles code credits: Openapi chat GPT 3.5
    let styles;

  switch (version) {
    case "v1":
      styles = stylesV1;
      break;
    case "v2":
      styles = stylesV2;
      break;
    case "v3": 
      styles = stylesV3;
      break;
    case "v4":
      styles = stylesV4;
      break;
    case "v5":
      styles = stylesV5;
      break;
    // case "v6":
    //   styles = stylesV6;
    //   break;
    default:
      // Use a default style if version doesn't match any of the cases
      styles = stylesV1;
  }

    // the different elements is conditionally rendered, based on wether the corresponding argument is given or null/empty
    return (
      <div className={styles.pageInfo}>
        <FadeInSection>
        {title && <h2 className={styles.header}>{title}</h2>}
        <hr className={styles.line}/>
        {image && (
          <div
            className={styles.image}
            style={{ backgroundImage: `url(${image})` }}
          ></div>
        )}
        {description && <p className={styles.textBox}>{description}</p>}
        </FadeInSection> 
      </div>
  );
}